import 'react-app-polyfill/ie11'; // For IE 11 support
import 'react-app-polyfill/stable';
import 'core-js';
import './polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Auth0Provider } from "./react-auth0-spa";
//import config from "./auth_config.json";
import history from "./utils/history";
import { icons } from './assets/icons';
import { Provider } from 'react-redux';
import store from './store';

React.icons = icons

const url = window.location.href;
const inviteMatches = url.match(/invitation=([^&]+)/);
const orgMatches = url.match(/organization=([^&]+)/);


// A function that routes the user to the right place
// after login
const onRedirectCallback = appState => {
  history.push(
    appState && appState.targetUrl
      ? appState.targetUrl
      : window.location.pathname
  );
};

ReactDOM.render(
  
    <Provider store={store}>
      <Auth0Provider
        domain={process.env.REACT_APP_AUTH_DOMAIN}
        client_id={process.env.REACT_APP_AUTH_CLIENT_ID}
        redirect_uri={process.env.REACT_APP_URL}
        audience={process.env.REACT_APP_AUTH_AUDIENCE}
        scope={process.env.REACT_APP_AUTH_SCOPE}
        onRedirectCallback={onRedirectCallback}
        organization={orgMatches === null ? undefined : orgMatches[1]}
        invitation={inviteMatches === null ? undefined : inviteMatches[1]}
      >
        <App />
      </Auth0Provider>
    </Provider>
  ,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
